/**
 * Inserts "Vejl. udsalgspris" before WPD cross-out prices.
 * WPD replaces price markup client-side, so Liquid-only labels are not enough.
 */
(function () {
  const LABEL =
    document.documentElement.dataset.mstRrpLabel || 'Vejl. udsalgspris';
  const CONTAINER_SELECTOR =
    '.mst-product__price, .mst-product-card__price, .mst-product__upsell-price';

  /** @param {Element} element */
  function hasLineThrough(element) {
    return window
      .getComputedStyle(element)
      .textDecorationLine.includes('line-through');
  }

  /** @param {Element} container */
  function findCompareElement(container) {
    const explicit = container.querySelector(
      '.compare-at-price, .data-wpd-hide, del, s'
    );
    if (explicit?.textContent?.trim()) return explicit;

    for (const element of container.querySelectorAll('span, s, del')) {
      if (element.textContent?.trim() && hasLineThrough(element)) {
        return element;
      }
    }

    return null;
  }

  /** @param {Element} container */
  function decorateContainer(container) {
    if (!(container instanceof HTMLElement)) return;

    const compareElement = findCompareElement(container);
    if (!compareElement || compareElement.closest('.mst-rrp')) return;

    const rrp = document.createElement('span');
    rrp.className = 'mst-rrp';

    let label = null;
    if (compareElement.previousElementSibling?.classList.contains('mst-rrp__label')) {
      label = compareElement.previousElementSibling;
      label.remove();
    }

    if (!label) {
      label = document.createElement('span');
      label.className = 'mst-rrp__label';
      label.textContent = LABEL;
    }

    compareElement.parentNode?.insertBefore(rrp, compareElement);
    rrp.appendChild(label);
    rrp.appendChild(compareElement);
  }

  function decorateAll() {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(decorateContainer);
  }

  let debounceId = 0;
  function scheduleDecorate() {
    window.clearTimeout(debounceId);
    debounceId = window.setTimeout(decorateAll, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateAll, { once: true });
  } else {
    decorateAll();
  }

  window.setTimeout(decorateAll, 300);
  window.setTimeout(decorateAll, 1200);

  const observer = new MutationObserver(scheduleDecorate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
